<div class="container" style="display: flex; flex-direction: column; height: 100%;">

  <div class="row justify-content-center" style="margin-top: 20px;">

    <div class="col">
      <img src="../../assets/images/noaa-emblem-rgb-withspace-2022.png" class="center" height="130" width="130" />
    </div>

    <div class="col">
      <img src="../../assets/images/PSMFCLogo.png" class="center" height="130" width="130" />
    </div>

  </div>

  <div class="row justify-content-center" style="margin-bottom: 5px; margin-top: 15px;">
    <div class="col">
      <img src="../../assets/images/FishVueFloat FullColour Horizontal.png" class="center" style="height: auto; max-width: 100%; width: 225px;" />
    </div>
  </div>

  <h1 class="display-6" align="center" style="font-weight: bolder; margin-bottom: 0px; font-size:30px;">
    Welcome to NOAA Fisheries West Coast Logbook
  </h1>

  <div *ngIf="sending" style="display:flex; flex-direction: column;">
    <span style="font-style:italic; font-weight:bolder;" align="center">We're setting up your new account, please wait...</span>
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  </div>
  <br>
  <div class="row justify-content-center">

    <div class="center">

      <form [formGroup]="signupForm" align="center">

        <div class="row justify-content-center">

          <mat-form-field appearance="fill">
            <mat-label>Vessel Operator First Name</mat-label>
            <input matInput formControlName="vesselOpFirstName" required>
            <mat-error *ngIf="signupForm.invalid">Required</mat-error>
          </mat-form-field>

        </div>

        <div class="row justify-content-center">

          <mat-form-field appearance="fill">
            <mat-label>Vessel Operator Last Name</mat-label>
            <input matInput formControlName="vesselOpLastName" required>
            <mat-error *ngIf="signupForm.invalid">Required</mat-error>
          </mat-form-field>

        </div>

        <div class="row justify-content-center">

          <mat-form-field appearance="fill">
            <mat-label>Username</mat-label>
            <input matInput formControlName="username" required>
            <mat-error>{{usernameError}}</mat-error>
          </mat-form-field>

        </div>

        <!-- Hide password button -->
        <div class="row justify-content-center" [style.padding-top]="applyPadding ? '45px' : ''">

          <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input matInput
                   required
                   formControlName="password"
                   [type]="hide ? 'password' : 'text'">
            <button mat-icon-button
                    matSuffix
                    type="button"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                    (click)="hide = !hide">
              <mat-icon>
                {{hide ? 'visibility_off' : 'visibility'}}
              </mat-icon>
            </button>
            <mat-error *ngIf="signupForm.get('password')?.errors?.minlength || signupForm.get('password')?.errors?.required">Minimum 8 characters required</mat-error>
            <mat-error *ngIf="signupForm.get('password')?.errors?.maxlength">Max 50 characters allowed</mat-error>
          </mat-form-field>

        </div>

        <div class="row justify-content-center">

          <mat-form-field appearance="fill">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" required>
            <mat-icon matSuffix>mail</mat-icon>
            <mat-error *ngIf="signupForm.get('email')?.errors?.required">Required</mat-error>
            <mat-error *ngIf="signupForm.get('email')?.errors?.pattern">Invalid email</mat-error>
          </mat-form-field>

        </div>

        <div class="row justify-content-center">

          <mat-form-field #telField appearance="fill">
            <mat-label>Phone Number</mat-label>
            <app-tel-input #telInput formControlName="phoneNumber"></app-tel-input>
            <mat-icon matSuffix>phone</mat-icon>
            <mat-error *ngIf="!signupForm.get('phoneNumber')?.value">Required</mat-error>
          </mat-form-field>

        </div>

        <div class="row justify-content-center">

          <mat-form-field appearance="fill">
            <mat-label>State Fisher License Number</mat-label>
            <input matInput [formControl]="vesselOpNumber">
            <mat-error *ngIf="vesselOpNumber.errors?.maxlength || vesselOpNumber.errors?.minlength">5 - 8 characters required</mat-error>
            <mat-error *ngIf="vesselOpNumber.errors?.pattern">Invalid character: Numbers and letters only</mat-error>
          </mat-form-field>

        </div>

        <mat-divider></mat-divider>

        <div style="margin-top: 12px;">
          <h3 align="center" style="font-weight: bolder; margin-bottom: 0px; font-size:24px;">Select Fishery</h3>

          <mat-radio-group formControlName="fishery" color="accent"
                           style="display: flex; flex-direction: column; align-items: flex-start;">
            <!--mat-radio-button value="trawl" style="margin-bottom: 4px;">
              Groundfish Trawl
            </mat-radio-button-->
            <mat-radio-button value="groundfishNonTrawl" style="margin-bottom: 4px;">
              Groundfish Non-Trawl
            </mat-radio-button>
            <mat-radio-button value="hms" style="margin-bottom: 4px;">
              HMS
            </mat-radio-button>
            <!--mat-radio-button value="both" style="margin-bottom: 4px;">
              Groundfish Non-Trawl + HMS
            </mat-radio-button-->
          </mat-radio-group>

          <mat-error *ngIf="attemptedSend && signupForm.get('fishery')?.errors?.required">
            Please select a fishery
          </mat-error>
        </div>

        <mat-divider></mat-divider>

      </form>

    </div>

  </div>

  <!-- Sign Up to continue account creation -->
  <div class="row" style="margin-right: 5px; margin-left: 5px; margin-top: 20px;">
    <div class="col">
      <div class="row">
        <button mat-stroked-button
                class="color-button-orange"
                type="submit"
                aria-label="Sign Up"
                [disabled]="sending"
                (click)="goToVesselRegistration()">
          <span>Sign Up</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <br>

  <!-- Back to log in screen -->
  <div class="row" style="margin-right: 5px; margin-left: 5px; margin-top: 15px;">
    <div class="col">
      <div class="row" style="margin-bottom: 15px;">
        <button mat-stroked-button
                class="color-button-blue"
                type="button"
                [disabled]="sending"
                (click)="router.navigate(['login'])">
          <mat-icon>
            arrow_back
          </mat-icon>
          Return to Login
        </button>
      </div>
    </div>
  </div>

</div>
